export const SITE_MEDIA_DEFAULTS = {
  hero: "https://images.unsplash.com/photo-1778534013714-e7ebe440558c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  tiles: "https://images.unsplash.com/photo-1751380293410-646969a08fc7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};